/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Drop_DescInputs */

const en_dialog_drop_desc = /** @type {(inputs: Dialog_Drop_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs, web articles, research papers & more.`)
};

const es_dialog_drop_desc = /** @type {(inputs: Dialog_Drop_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs, artículos web, artículos de investigación y más.`)
};

/**
* | output |
* | --- |
* | "PDFs, web articles, research papers & more." |
*
* @param {Dialog_Drop_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_drop_desc = /** @type {((inputs?: Dialog_Drop_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Drop_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_drop_desc(inputs)
	return en_dialog_drop_desc(inputs)
});